import { create } from 'zustand';
import { AdminUser } from '@models/auth';

interface AdminUserManagementState {
  users: AdminUser[];
  usersContainer: {
    totalCount: number;
  } | null;
  searchQuery: {
    keyword?: string;
    page: number;
    size: number;
  };
  setUsers: (users: AdminUser[]) => void;
  setUsersContainer: (container: { totalCount: number }) => void;
  setSearchQuery: (query: Partial<AdminUserManagementState['searchQuery']>) => void;
}

export const useAdminUserManagementStore = create<AdminUserManagementState>((set) => ({
  users: [],
  usersContainer: null,
  searchQuery: {
    page: 0,
    size: 20,
  },
  setUsers: (users) => set({ users }),
  setUsersContainer: (usersContainer) => set({ usersContainer }),
  setSearchQuery: (query) =>
    set((state) => ({
      searchQuery: { ...state.searchQuery, ...query },
    })),
}));
